import React from 'react';
import { Avatar } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';
import { getInitialsName } from 'packages/utils';
import { groupsFromMembers, usersFromMembers } from 'packages/utils/proptypes/user';
import styles from './styles.module.less';
import PropTypes from 'prop-types';

const MemberAvatar = ({ user = {}, size = 24 }) => {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  const displayName = name || user.displayName || user.name || '';
  const photo = user.photoURL ? user.photoURL.trim() : null;
  if (user.hasOwnProperty('users'))
    return <Avatar className={styles.avatarGroup} size={size} icon={<UsergroupAddOutlined />} />;
  return (
    <Avatar size={size} src={photo} className={styles.avatarColor}>
      {getInitialsName(displayName)}
    </Avatar>
  );
};

MemberAvatar.propTypes = {
  user: PropTypes.oneOfType([usersFromMembers, groupsFromMembers]),
  size: PropTypes.number,
};

export default MemberAvatar;
